import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Route } from '../../../../models/alarmroutes.model';
import { StaffModel } from '../../../../models/staff.model';
import { ReceiverTeam } from '../../../../models/receiver-team';
import { AlarmRouteRecipientsComponent } from '../alarm-route-recipients/alarm-route-recipients.component';
import { IRoleSymbols } from 'app/models/permission.model';
import { NO_ROLE_SYMBOLS } from 'app/shared/role-symbol/role-symbol';

@Component({
    selector: 'alarm-route-fallback-recipients',
    templateUrl: './alarm-route-fallback-recipients.component.html',
    styleUrls: ['./alarm-route-fallback-recipients.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [AlarmRouteRecipientsComponent]
})
export class AlarmRouteFallbackRecipientsComponent {

  @Input() tempRoute: Route;
  @Input() allStaff: StaffModel[] = [];
  @Input() allReceiverTeams: ReceiverTeam[] = [];
  @Input() customerInformation: any;
  @Input() roleSymbols: IRoleSymbols = NO_ROLE_SYMBOLS;
}
